/* eslint-disable import/order */
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssuesExplicitFieldAssociationRoute } from '@jira/router-routes__admin-pages-issues-explicit-field-association-routes/src/globalSettingsIssuesExplicitFieldAssociationRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	LazyExplicitFieldsProjectListPage,
	LazyExplicitFieldsProjectListPromise,
} from './ui/spa/index.tsx';

export const globalSettingsIssuesExplicitFieldAssociationRouteEntry: Route = createEntry(
	globalSettingsIssuesExplicitFieldAssociationRoute,
	() => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		// eslint-disable-next-line no-restricted-syntax
		component: LazyExplicitFieldsProjectListPage,
		forPaint: [LazyAtlassianNavigation, LazyExplicitFieldsProjectListPromise],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
